/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![FoodIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABV0lEQVR4nNWTS0rEQBCGgwvdudKteArxCC12V1WQpCoMcwYZd4OLnMHXHVy40IUewEF04RUEUU8gPmbjg+5JJJhJJsQeBgsKUqT7//L/6Q6CWZUhuQLkwVTEVRQtA8kXEL9MBQjEuxZgSC4dUHUWR0AZ+hDfAZJPJxjKJiKvGuKzIrC9OAg4IeQPIN42YbxuY8rEn4mStSiK5gGkZ4hvAfndtnsG6dl3tQCX80isX5wB5VTraMVFhXKdxVVqQ3xj19TEI692odbJUjYP7ZxvAuKjKvGfRjmoBiAPijmXZ7mYBDDE58FMyuR5+2gcc1/yvH20QXkrA5DvPTq4G+OAT7w5IDkuA8K4481BGEsJoJRaAJInD1//UHmjDUn8V4DGZKv+uCIftj89vBdMqjRN59pBeN/uDZqWRu42j4W7jYV/xfXY5Ke2EncuiDfqIFbchKJaA/5FfQPHAg+3mMZhlgAAAABJRU5ErkJggg==)
 */
export const FoodIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M7 1a1 1 0 0 0-1 1v.2c0 .79-.4 1.53-1.05 1.97A4.37 4.37 0 0 0 3 7.8V8a1 1 0 0 0 2 0v-.2c0-.79.4-1.53 1.05-1.97A4.37 4.37 0 0 0 8 2.2V2a1 1 0 0 0-1-1ZM10 3a1 1 0 1 1 2 0v.42a3.2 3.2 0 0 1-2.18 3.03A1.2 1.2 0 0 0 9 7.58V8a1 1 0 0 1-2 0v-.42c0-1.37.88-2.6 2.18-3.03.5-.16.82-.62.82-1.13V3ZM2 11a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1 10 10 0 0 1-4.7 8.49.6.6 0 0 0-.3.51 2 2 0 0 1-2 2H9a2 2 0 0 1-2-2 .6.6 0 0 0-.3-.51A10 10 0 0 1 2 11ZM20.85 8.02c.16.52-.3.98-.85.98h-8c-.55 0-1.01-.46-.85-.98a4.07 4.07 0 0 1 1.31-1.84 5.23 5.23 0 0 1 1.63-.88 6.1 6.1 0 0 1 3.82 0c.61.2 1.16.5 1.63.87a4.07 4.07 0 0 1 1.3 1.85Z"
        className={colorClass}
      />
    </svg>
  );
};
